import React, { useState, useEffect } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { useSelector, useDispatch } from "react-redux";
import ThemMoiCamDo from "containers/DanhSachHopDongChoDuyet/Sua/suaCamDo";
import ThemMoiLoaiTaiSanContainer from "containers/Common/TaiSan/ThemMoiLoaiTaiSanContainer";
import ChiTietHopDong from "../../../../../../service/chiTietHopDongApi";
// import ThemMoiTraGop from "containers/TraGop/SubContainer/themMoiTraGop";
import { convertDate } from "utils/formatDate";
import { showFormTraGop } from "actions/ThemMoiTraGop";
import { pushNotification } from "utils/notifications";
import {
  getListHopDongChoDuyet,
  updateDataSearch,
} from "../../../../../../actions/DanhSachHopDongChoDuyet";
import { getLaiSuat } from "constants/choVayConst";
import { getTotalDays } from "utils/choVayUtils";
export const BtnSuaCamDo = ({
  item,
  showFormCamDo,
  showModalLoaiTaiSan,
  loaitaisan,
  isDuDungPhiPhatDongLaiTatToan,
  SuDungPhiPhat_DongLai_Cham,
  isSuDungCongTacVienNhanVien,
  isSuDungTatToanSom,
}) => {
  const [isModalVisible, setModalVisible] = useState(false);

  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchHopDongChoDuyet);

  const themmoicamdo = useSelector((state) => state.themmoicamdo);

  const choVayEdit = {};
  const [chovayChiTiet, setChoVay] = useState(choVayEdit);

  const loadCamDo = () => {
    getListHopDongChoDuyet(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang

  const setModalCamDoShow = (chovay) => {
    let choVayEdit = { ...chovay };
    if (chovay) {
      choVayEdit.NgayVay = convertDate(chovay.NgayVay);
      choVayEdit.NgayTra = convertDate(chovay.NgayTra);
      choVayEdit.LaiSuat = getLaiSuat(chovay, chovay.KieuLaiSuat);
      choVayEdit.TongNgayVay = getTotalDays(
        choVayEdit.NgayVay,
        choVayEdit.NgayTra
      );
      if (choVayEdit.kyLai && parseFloat(choVayEdit.kyLai) > 0)
        choVayEdit.CountTypePaid = choVayEdit.kyLai;
      choVayEdit.NgayThanhToan = convertDate(chovay.DatePaid);
    }
    ChiTietHopDong.getChiTietHopDong1(item.ChoVayId).then((response) => {
      setChoVay(response.data);
    });

    themmoicamdo.postCamDoReturn = false;
    let { isShowFormCamDo } = themmoicamdo;
    if (isShowFormCamDo) {
      if ((choVayEdit.ChoVayId = undefined || choVayEdit.ChoVayId == 0)) {
        dataSearch.pageIndex = 1;
      }
      // dataSearch.pageIndex = 1;
      loadCamDo(dataSearch);
    }
    showFormCamDo(choVayEdit);
    dispatch(getListHopDongChoDuyet(dataSearch));
    setModalVisible(!isModalVisible);
  };

  const hideModalLoaiTaiSanTM = () => {
    showModalLoaiTaiSan(false);
  };

  return (
    <>
      <a onClick={(e) => setModalCamDoShow(item)} href={() => false}>
        <PopoversBootrap
          contentText="Sửa"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
           <img src="/app-assets/images/icon-edit-v2.png" />
        </PopoversBootrap>
      </a>

      {isModalVisible && (
        <ThemMoiCamDo
          show={isModalVisible}
          onHide={setModalCamDoShow}
          data={chovayChiTiet}
          isDuDungPhiPhatDongLaiTatToan={isDuDungPhiPhatDongLaiTatToan}
          SuDungPhiPhat_DongLai_Cham={SuDungPhiPhat_DongLai_Cham}
          isSuDungCongTacVienNhanVien={isSuDungCongTacVienNhanVien}
          isSuDungTatToanSom={isSuDungTatToanSom}
        ></ThemMoiCamDo>
      )}
      {loaitaisan.isShowModalLoaiTaiSan && (
        <ThemMoiLoaiTaiSanContainer
          show={loaitaisan.isShowModalLoaiTaiSan}
          onHide={hideModalLoaiTaiSanTM}
        ></ThemMoiLoaiTaiSanContainer>
      )}
    </>
  );
};
